(function () {
  'use strict';
  angular.module('app').controller('AccountingUnprocessedController', AccountingUnprocessedController);
  AccountingUnprocessedController.$inject = [
    'AccountingUnprocessedShipmentsTable',
    'ArchivedShipmentsTable',
    'UnprocessBreakBulkShipmentsTable'
  ];

  function AccountingUnprocessedController(
    AccountingUnprocessedShipmentsTable,
    ArchivedShipmentsTable,
    UnprocessBreakBulkShipmentsTable
  ) {
    const vm = this;

    init();
    function init() {
      setupShipmentsTable();
    }

    function setupShipmentsTable() {
      let defaultFilters = {
        unprocessedShipment: true
      };
      let presetfilter = angular.fromJson(localStorage.getItem('shipmentsFilter'));
      localStorage.removeItem('shipmentsFilter');
      if (presetfilter) {
        defaultFilters = presetfilter;
      }

      vm.unprocessedShipmentsTableData = new AccountingUnprocessedShipmentsTable().tableData;
      vm.archiveInvoicesTable = new ArchivedShipmentsTable(defaultFilters).tableData;
      let breakBulkfilter = {
        breakBulk: true,
        reconciled: false,
        paid: false,
        bookingStatus: 'processed',
        archived: true
      }
      vm.unprocessedBreakBulkTableData = new UnprocessBreakBulkShipmentsTable(breakBulkfilter).tableData;
    }
  }
})();


// WEBPACK FOOTER //
// ./js/controllers/accounting/AccountingUnprocessedController.js